/**
 * AdminFormFieldDescriptor
 *
 * Minimal generic field descriptor contract for Q360 Admin
 * business forms.
 *
 * This module contains no business-domain vocabulary and no
 * rendering responsibility.
 */

export const ADMIN_FORM_FIELD_TYPES = Object.freeze([
  "text",
  "textarea",
  "number",
  "select",
  "boolean",
]);


export function isAdminFormFieldType(type) {
  return ADMIN_FORM_FIELD_TYPES.includes(type);
}


export function createAdminFormFieldDescriptor({
  name,
  label,
  type,
  required = false,
  disabled = false,
  placeholder = null,
  description = null,
  options = null,
  min = null,
  max = null,
  step = null,
  validate = null,
}) {
  if (
    typeof name !== "string"
    || name.trim() === ""
  ) {
    throw new TypeError(
      "Admin form field descriptor requires a non-empty name."
    );
  }

  if (
    typeof label !== "string"
    || label.trim() === ""
  ) {
    throw new TypeError(
      "Admin form field descriptor requires a non-empty label."
    );
  }

  if (!isAdminFormFieldType(type)) {
    throw new TypeError(
      `Unsupported Admin form field type: ${String(type)}`
    );
  }

  if (
    options !== null
    && !Array.isArray(options)
  ) {
    throw new TypeError(
      "Admin form field descriptor options must be an array."
    );
  }

  if (
    validate !== null
    && typeof validate !== "function"
  ) {
    throw new TypeError(
      "Admin form field descriptor validate must be a function."
    );
  }

  return Object.freeze({
    name,
    label,
    type,
    required: Boolean(required),
    disabled: Boolean(disabled),
    placeholder,
    description,
    options:
      options === null
        ? null
        : Object.freeze(
            options.map((option) =>
              Object.freeze({
                ...option,
              })
            )
          ),
    min,
    max,
    step,
    validate,
  });
}


export function validateAdminFormFieldValue(
  descriptor,
  value
) {
  if (
    descriptor.required
    && (
      value === null
      || value === undefined
      || value === ""
    )
  ) {
    return "Ce champ est obligatoire.";
  }

  if (
    typeof descriptor.validate
      === "function"
  ) {
    const result =
      descriptor.validate(value);

    if (
      result === null
      || result === undefined
      || result === true
    ) {
      return null;
    }

    if (result === false) {
      return "Valeur invalide.";
    }

    return String(result);
  }

  return null;
}
